import React from 'react';

const TagPage = () => {
  return <div>TagPage</div>;
};

export default TagPage;
